import { ActionType } from '../constants/ActionTypes'
export default function pagesReducer(state = {}, action = {}) {
    switch (action.type) {
        // Get Pages
        case ActionType.GET_PAGE_BEGIN:
        case ActionType.GET_BACKGROUNDS_BEGIN:
            return {
                ...state,
                error: null,
                isLoading: true
            }
        case ActionType.GET_PAGE_SUCCESS:
            return {
                ...state,
                page: action.payload.data,
                isLoading: false
            }
        case ActionType.GET_BACKGROUNDS_ERROR:
        case ActionType.GET_PAGE_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        // Get Backgrounds
        case ActionType.GET_BACKGROUNDS_SUCCESS:
            return {
                ...state,
                backgrounds: action.payload,
                isLoading: false
            }
        case ActionType.RESET_PAGE:
            return {
                ...state,
                page: {}
            }
        case ActionType.GET_BONUS_CAMPAIGNS_PAGE_BEGIN:
            return {
                ...state,
                campaignDataLoading: true,
            }
        case ActionType.GET_BONUS_CAMPAIGNS_PAGE_ERROR:
            return {
                ...state,
                campaignDataLoading: false,
            }
        case ActionType.GET_BONUS_CAMPAIGNS_PAGE_SUCCESS:
            const { id, data } = action.payload

            return {
                ...state,
                campaignData: {
                    ...state.campaignData,
                    [id]: data,
                },
                campaignDataLoading: false,
            }
        case ActionType.JOIN_BONUS_CAMPAIGNS_PAGE_BEGIN:
            return {
                ...state,
                campaignData: {
                    ...state.campaignData,
                    joinCampaignLoading: true,
                }
            }
        case ActionType.JOIN_BONUS_CAMPAIGNS_PAGE_ERROR:
            return {
                ...state,
                campaignData: {
                    ...state.campaignData,
                    joinCampaignLoading: false,
                }
            }
        case ActionType.JOIN_BONUS_CAMPAIGNS_PAGE_SUCCESS:
            return {
                ...state,
                campaignData: {
                    ...state.campaignData,
                    joinCampaignLoading: false
                }
            }
        default:
            return state;
    }

}

